import React, { useEffect, useState } from 'react';
import { LicenseInfo } from '@mui/x-license-pro';
import { useZone } from 'core/contexts';
import { AcceptableUsePolicy, DataZoneSelector } from 'core/components';
import { AppRoutes } from '../app-routes/AppRoutes';
import {
    MUI_GRID_PRO_KEY,
    excludedHeaderSidenavPaths,
} from 'constants/app.constants';
import { AppContainer } from '../app-container/AppContainer';
import { useLocation } from 'react-router-dom';
import { useIsPolicySigned } from 'hooks';
import { HelixLoaderComponent } from 'components/helix-loader/HelixLoaderComponent';
export const AppInitializer = (): React.JSX.Element => {
    const { data: signedPolicyData, isLoading: signedPolicyDataLoading } =
        useIsPolicySigned();
    const { getSelectedDataZone, loadAvailableDataZones } = useZone();
    const [isPolicySigned, setIsPolicySigned] = useState<boolean>(false);
    const selectedEnv = getSelectedDataZone();
    const location = useLocation();

    // Register MUI Data Grid License
    const updateDataGridProWithKey = (): void => {
        LicenseInfo.setLicenseKey(MUI_GRID_PRO_KEY || '');
    };
    updateDataGridProWithKey();
    useEffect(() => {
        loadAvailableDataZones();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (!signedPolicyDataLoading) {
            if (signedPolicyData?.data?.length) {
                setIsPolicySigned(false);
            } else {
                setIsPolicySigned(true);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [signedPolicyDataLoading]);

    const renderAppRoutes = (): React.JSX.Element => {
        if (!isPolicySigned && signedPolicyData?.data?.length) {
            return (
                <AcceptableUsePolicy
                    content={
                        !signedPolicyDataLoading &&
                        signedPolicyData?.data?.length &&
                        signedPolicyData?.data[0]?.documentBase64
                    }
                    id={
                        !signedPolicyDataLoading &&
                        signedPolicyData?.data?.length &&
                        signedPolicyData?.data[0]?.id
                    }
                    setIsPolicySigned={setIsPolicySigned}
                />
            );
        } else {
            return (
                <div>
                    {excludedHeaderSidenavPaths.includes(location.pathname) ? (
                        <AppRoutes />
                    ) : (
                        <AppContainer>
                            <AppRoutes />
                        </AppContainer>
                    )}
                </div>
            );
        }
    };

    if (signedPolicyDataLoading) {
        return <HelixLoaderComponent />;
    }

    return <>{selectedEnv ? renderAppRoutes() : <DataZoneSelector />}</>;
};
